var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"color":_vm.$variables.colors.red,"timeout":10000},model:{value:(_vm.open_snackbar),callback:function ($$v) {_vm.open_snackbar=$$v},expression:"open_snackbar"}},[_vm._v(_vm._s(_vm.error))])}
var staticRenderFns = []

export { render, staticRenderFns }